/*
 * Copyright (c) 2022. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// models and services
import { CalloutViewModel } from 'src/types/view-models/callout.view.model';

// stylesheets and icons
import styles from './Callout.module.scss';

export default class Callout extends Component<CalloutViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className={this.getClasses()} data-cy="calloutMain">
                {this.props.icon}
                {this.props.text ? (
                    <Typography variant={TypographyVariants.SUBTEXT}>{this.props.text}</Typography>
                ) : (
                    <div>{this.props.children}</div>
                )}
            </div>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        classes.push(styles.calloutMain);

        if (this.props.type) {
            classes.push(this.props.type);
        }

        if (this.props.defaultWidth) {
            classes.push(styles.calloutDefaultWidth);
        } else {
            classes.push(styles.calloutFullWidth);
        }

        if (this.props.className) {
            classes.push(this.props.className);
        }

        if (this.props.noMargin) {
            classes.push(styles.calloutNoMargin);
        }

        return classes.join(' ');
    }
}
